var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRgb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#fff"
    },
    cx: 12,
    cy: 8,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#fff"
    },
    cx: 7,
    cy: 15,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#fff"
    },
    cx: 17,
    cy: 15,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M255.979,209.068c17.354,12.762,32.417,29.232,43.877,49.082c11.46,19.85,18.193,41.13,20.568,62.54 c51.474-22.563,88.845-71.319,95.255-129.41C362.166,167.786,301.256,175.772,255.979,209.068z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M191.534,320.69c2.375-21.41,9.107-42.69,20.568-62.54c11.46-19.85,26.523-36.32,43.877-49.082 c-45.277-33.295-106.187-41.282-159.7-17.788C102.689,249.371,140.062,298.127,191.534,320.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M320.424,320.69c-19.729,8.648-41.523,13.458-64.445,13.458s-44.715-4.81-64.445-13.458 c-6.197,55.858,17.341,112.601,64.445,147.199C303.083,433.291,326.621,376.548,320.424,320.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M255.979,209.068c-17.354,12.762-32.417,29.232-43.877,49.082 c-11.46,19.85-18.193,41.13-20.568,62.54c19.729,8.648,41.523,13.458,64.445,13.458s44.715-4.81,64.445-13.458 c-2.375-21.41-9.107-42.69-20.568-62.54C288.396,238.3,273.333,221.83,255.979,209.068z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRgb);
export default __webpack_public_path__ + "static/media/rgb.4a64a9e9bf8cf59dba0643a512eab202.svg";
export { ForwardRef as ReactComponent };